export default __webpack_public_path__ + "img/dSbGYXbE.1a7e7eea.svg";